export type UiConfigEditorDraftStatus = {
  primaryLabel: string
  secondaryLabel: string | null
  compareLabel: string
  primaryTone: 'saved' | 'published' | 'draft'
}

export function getUiConfigEditorDraftStatus(isPublished: boolean, hasDraft: boolean): UiConfigEditorDraftStatus {
  if (hasDraft) {
    return {
      primaryLabel: 'Unsaved draft',
      secondaryLabel: null,
      compareLabel: 'Compare',
      primaryTone: 'draft',
    }
  }

  return {
    primaryLabel: isPublished ? 'Published version' : 'Saved version',
    secondaryLabel: null,
    compareLabel: 'Compare',
    primaryTone: isPublished ? 'published' : 'saved',
  }
}
